import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jswStandardUnlimitedUsersTitle: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-unlimited-users-title',
		defaultMessage: 'Unlimited users',
		description: 'Modal dialog description that the Jira Standard plan has unlimited users title',
	},
	jswStandardUnlimitedUsersSubText: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-unlimited-users-sub-text',
		defaultMessage: 'Get your entire team in one tool',
		description:
			'Modal dialog description that the Jira Standard plan has unlimited users sub text',
	},
	jswStandardAuditLogTitle: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-audit-log-title',
		defaultMessage: 'Audit log',
		description: 'Modal dialog description that the Jira Standard plan has audit log title',
	},
	jswStandardAuditLogSubText: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-audit-log-sub-text',
		defaultMessage: 'Review and troubleshoot site changes',
		description: 'Modal dialog description that the Jira Standard plan has audit log sub text',
	},
	jswStandardAutomationsTitle: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-automations-title',
		defaultMessage: '1,700 automation runs',
		description:
			'Modal dialog description that the Jira Standard plan has 1700 automations per month',
	},
	jswStandardAutomationsSubText: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-automations-sub-text',
		defaultMessage: 'Save time by automating routine tasks',
		description:
			'Modal dialog description that the Jira Standard plan has 1700 automations per month',
	},
	jswStandardIssuePermissionsTitle: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-issue-permissions-title',
		defaultMessage: 'Issue permissions ',
		description: 'Modal dialog description that the Jira Standard plan issue permissions title',
	},
	jswStandardIssuePermissionsSubText: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-issue-permissions-sub-text',
		defaultMessage: 'Decide who can view, comment, and create',
		description: 'Modal dialog description that the Jira Standard plan issue permissions subtext',
	},
	jswStandardStorageTitle: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-storage-title',
		defaultMessage: '250 GB of storage',
		description:
			'Modal dialog description that the Jira Standard plan has 250GB storage limit title',
	},
	jswStandardStorageSubText: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-storage-sub-text',
		defaultMessage: 'Upload files without running out of space',
		description:
			'Modal dialog description that the Jira Standard plan has 250GB storage limit subtext',
	},
	jswStandardCarouslSlideUserLimit: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-user-limit',
		defaultMessage: 'Unlimited People',
		description: 'Modal dialog description that the Jira Standard plan has unlimted user',
	},
	jswStandardCarouslSlideAuditLog: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-audit-log',
		defaultMessage: 'Audit Log',
		description: 'Modal dialog carousel slide text for audit log',
	},
	jswStandardCarouslSlideUserAutomation: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-user-automation',
		defaultMessage: 'Automation',
		description: 'Modal dialog carousel slide text for automation',
	},
	jswStandardCarouslSlideUserPermissions: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-user-permissions',
		defaultMessage: 'User permissions',
		description: 'Modal dialog carousel slide text for user permission',
	},
	jswStandardCarouslSlideStorageLimit: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-storage-limit',
		defaultMessage: 'Storage limit',
		description: 'Modal dialog carousel slide text for storage limit',
	},
});
